import { render, staticRenderFns } from "./SmTextVHtml.vue?vue&type=template&id=7e640618&scoped=true&"
import script from "./SmTextVHtml.vue?vue&type=script&lang=ts&"
export * from "./SmTextVHtml.vue?vue&type=script&lang=ts&"
import style0 from "./SmTextVHtml.vue?vue&type=style&index=0&id=7e640618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e640618",
  null
  
)

export default component.exports